import { HeaderLogo, HeaderTitle } from '@doda/io-react/pc';
import { DEFAULT_LEAD_SENTENCE } from 'constants/headerLeadSentence';
import styles from './index.module.scss';

/**
 * ヘッダーロゴのみを持つヘッダー
 */
export const SimpleHeader = () => {
  return (
    <header className={styles.simpleHeader}>
      <div className={styles.simpleHeader__inner}>
        <div className={styles.simpleHeader__logo}>
          <HeaderLogo
            imgUrl="https://doda.jp/cmn_web/img/logo_doda/logo_slogan_bg_195x52_endorse.png"
            alt="はたらく今日が、いい日に。"
            href="/"
          />
          <HeaderTitle title={DEFAULT_LEAD_SENTENCE} as="p" />
        </div>
      </div>
    </header>
  );
};
